import React, { Component } from 'react';
import { Row, Col, } from 'reactstrap';
import { HORIZONTAL } from '../../constants';

class AggregatePredefined extends Component {
    render() {
        return (
            <Col xs='24'>
                <Row className="header-blue ">
                    <Col xs="5" >Field Name</Col>
                    <Col xs="4" >Credit Worthiness</Col>
                    <Col xs="3" >Field Type</Col>
                    <Col xs="4" >Direction</Col>
                    <Col xs="6" >Value</Col>
                </Row>
                {
                    this.props.predefinedData.map(p => {
                        return (
                            <Row key={p.id} className="modal-report-type-item">
                                <Col xs="5">{p.fieldName}</Col>
                                <Col xs="4">{(p.creditWorthinessField) ? p.creditWorthinessField.name : ''}</Col>
                                <Col xs="3">{p.fieldType}</Col>
                                <Col xs="4">{p.fieldDirection}</Col>
                                <Col xs="6">{(p.fieldType === HORIZONTAL) ? (p.fromDate + '-' + p.toDate).toString() : ''}</Col>
                            </Row>
                        )
                    })
                }
            </Col>
        )
    }
}

export default AggregatePredefined